



















import { Component, Vue } from 'vue-property-decorator';
import UserProfile from '@/modules/organisation/pages/UserProfile.vue';

@Component({
  name: 'profile',

  components: {
    UserProfile,
  },
  layout: 'AppMain',
})
export default class Profile extends Vue {}
